"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insetElementShape = exports.inputPropTypes = exports.inputBasePropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _propTypes = require("../prop-types");
const insetElementShape = exports.insetElementShape = {
  element: _stencilReactDesc.PropTypes.node,
  width: _stencilReactDesc.PropTypes.number,
  inset: _stencilReactDesc.PropTypes.number
};
const inputBasePropTypes = exports.inputBasePropTypes = {
  ..._propTypes.alignSelfPropTypes,
  ..._propTypes.flexPropTypes,
  ..._propTypes.formElementPropTypes,
  ..._propTypes.readOnlyPropsTypes,
  ..._propTypes.widthWithMinMaxPropTypes,
  id: _stencilReactDesc.PropTypes.string.description('Identifier for the field. Must be unique amongst all the form elements on the page.'),
  name: _stencilReactDesc.PropTypes.string.description('Name of the field to use when submitting a form.'),
  placeholder: _stencilReactDesc.PropTypes.string.description('Displays placeholder text in the input field until the user begins typing.'),
  type: _stencilReactDesc.PropTypes.string.description("Type of text-based input the field accepts, such as 'text', 'number', 'email', 'password', 'tel' or 'url'."),
  autoComplete: _stencilReactDesc.PropTypes.string.description('Helps users fill in forms faster, and helps user agents and assistive technologies to indicate the purpose of the input.')
};
const inputPropTypes = exports.inputPropTypes = {
  ...inputBasePropTypes,
  insetElementLeading: _stencilReactDesc.PropTypes.shape(insetElementShape).description('Element to display inside the input on the leading side.'),
  insetElementTrailing: _stencilReactDesc.PropTypes.shape(insetElementShape).description('Element to display inside the input on the trailing side.')
};